///<reference path="./environments/Global.d.ts" />
import angular from "angular";
import "angular-resource";
import "angular-translate/dist/angular-translate";
import './style/index.less';

/************************************** Service ***********************************************/
import { BuilderUrlService } from "./rest/builder-url/builder-url.service";
import { ClientService } from "./rest/client/client.service";
import { InstanceService } from "./rest/instance/instance-rest.service";

/************************************** Config ***********************************************/
import { builderUrlServiceConfig } from "./rest/builder-url/builder-url.config";
import { clientServiceConfig } from "./rest/client/client.config";
import { instanceServiceConfig } from "./rest/instance/instance-rest.config";
import { injector as langInjector } from "./common/APP.Config";
/************************************** Controller ***********************************************/
import { BuilderOrdinaryDetailController } from "./token-test.controller";
/************************************** Module ***********************************************/
import { module_name as appConfig } from "./local-config";
import { name as accessor } from "./common/accessor.module";
import { RestfulAccessorProvider } from "./common/data-access/restful/restful-accessor.provider";
import { RuntimeContext } from "./common/EnvironmentsInfo";

let moduleName = "builder-ordinary";

angular.module(moduleName, ['ngResource', appConfig, accessor, 'pascalprecht.translate'])
    .controller({
        builderOrdinaryDetailController: BuilderOrdinaryDetailController
    })
    .service({
        instanceService: InstanceService,
        builderUrlService: BuilderUrlService,
        clientService: ClientService,
    })
    .config(["$accessorProvider", function ($accessorProvider: RestfulAccessorProvider) {
        $accessorProvider.config(builderUrlServiceConfig);
        $accessorProvider.config(clientServiceConfig);
        $accessorProvider.config(instanceServiceConfig);
    }])
    .config(langInjector)
    .value('runtimeContext', RuntimeContext);

export { moduleName }